/**
 * Created by renjie.huang on 2018/3/21.
 */
var xssFilters  = require('xss-filters');
var config = require('../config/config');
var _ = require('underscore');

var getServiceUrl = function(url){
    // service comes from the URL and may contain malformed percent-encoding.
    // Treat any value that cannot be decoded as invalid instead of interrupting
    // login page rendering.
    try {
        url = xssFilters.uriInHTMLData(decodeURIComponent(url));
    } catch (e) {
        return config.default;
    }
    url = url.replace(/@/g, '#');
    url = url.replace(/^javascript/, '')
    var whiteList = config.whiteList;
    var isInWhiteList = false;
    _.each(whiteList,function(item){
        isHttpUrl(url) && matchHostname(url,item) && (isInWhiteList = true)
    })
    if(isInWhiteList){
        return url;
    }else{
        return config.default;
    }
}


function isHttpUrl(url){
    return /^(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(url);
}

function matchHostname(url, item){
    try {
        // 使用浏览器实际解析出的 hostname，并将白名单匹配锚定到末尾，
        // 避免 console.ucloud.cn.attacker.com / *.nip.io 绕过。
        var hostname = new URL(url).hostname.toLowerCase();
        var flags = item.ignoreCase ? 'i' : '';
        var hostnamePattern = new RegExp('(?:' + item.source + ')$', flags);
        return hostnamePattern.test(hostname);
    } catch (e) {
        return false;
    }
}

module.exports = getServiceUrl;



// WEBPACK FOOTER //
// ./src/common/serviceUrl.js